import { jsx as V } from "react/jsx-runtime";
import { c as w } from "../../index-Cu0xwYjD.js";
import { forwardRef as L, useRef as S, useImperativeHandle as j, Children as b, isValidElement as q, cloneElement as d } from "react";
import { toArray as l } from "../../utils/helpers.js";
import { CheckboxGroupLayout as A } from "./CheckboxGroup.types.js";
import { useControlledState as H } from "../../utils/hooks/useControlledState.js";
const O = "ids-checkbox-group-v501", P = "ids-checkbox-group--block-v501", W = "ids-checkbox-group--stack-v501", z = "ids-checkbox-group--inline-v501", k = {
  checkboxGroup: O,
  block: P,
  stack: W,
  "ids-checkbox": "ids-checkbox-v501",
  "ids-checkbox--label": "ids-checkbox--label-v501",
  "ids-checkbox--label-span": "ids-checkbox--label-span-v501",
  inline: z
}, h = (u, c) => b.map(u, (e) => {
  if (!q(e))
    return e;
  const n = e.props.value;
  if (n) {
    const s = c(n);
    return d(
      e,
      s
    );
  }
  if (e.props.children) {
    const s = {
      children: h(
        e.props.children,
        c
      )
    };
    return d(e, s);
  }
  return e;
}), m = L(
  ({
    className: u,
    value: c,
    defaultValue: e,
    children: n,
    layout: s = "stack",
    onChange: v,
    onFocus: a,
    hiddenCheckbox: x,
    name: f,
    role: g = "group",
    ...C
  }, y) => {
    const { value: G, setValue: I, toggleValue: p } = H({
      component: "IressCheckbox",
      defaultValue: e === void 0 ? void 0 : l(e),
      multiple: !0,
      onChange: v,
      value: c === void 0 ? void 0 : l(c)
    }), i = S(null), o = i.current;
    j(y, () => ({
      // React hook form requires the focus, blur, input
      focus: () => o == null ? void 0 : o.focus(),
      blur: () => o == null ? void 0 : o.blur(),
      input: o,
      check: (r) => {
        p(r, !0);
      },
      reset: () => {
        I([]);
      }
    }));
    const N = (r) => {
      var t;
      a == null || a(r), r.target === i.current && ((t = i.current.querySelector("input")) == null || t.focus());
    };
    return /* @__PURE__ */ V(
      "div",
      {
        ...C,
        role: g,
        ref: i,
        className: w(u, k.checkboxGroup, k[s]),
        onFocus: N,
        children: b.map(
          n,
          (r) => h(r, (t) => ({
            name: f,
            hiddenControl: x,
            checked: l(G).includes(t),
            onChange: (R) => p(t, R.target.checked)
          }))
        )
      }
    );
  }
);
m.displayName = "IressCheckboxGroup";
m.Layout = A;
export {
  m as IressCheckboxGroup
};
